import { Group, HoverCard, Text } from '@mantine/core';
import { Trans } from 'react-i18next';
import { BsInfoCircle } from 'react-icons/bs';

interface Props {
  i18nKey: string;
  w?: number;
  testId?: string;
}

export const InfoIcon = ({ i18nKey, w = 800, testId }: Props) => {
  return (
    <HoverCard width={w} shadow={'md'} data-testid={testId}>
      <HoverCard.Target>
        <Group w={16}>
          <BsInfoCircle color={'var(--mantine-color-blue-5)'} />
        </Group>
      </HoverCard.Target>
      <HoverCard.Dropdown>
        <Text size={'sm'}>
          <Trans i18nKey={i18nKey} components={{ bold: <strong /> }} />
        </Text>
      </HoverCard.Dropdown>
    </HoverCard>
  );
};
